var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFlatTray = function SvgDownloadFlatTray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M10 2.5c.46 0 .833.373.833.833v8.822l2.744-2.744a.833.833 0 1 1 1.179 1.178l-4.167 4.167a.833.833 0 0 1-1.178 0l-4.167-4.167a.833.833 0 0 1 1.179-1.178l2.744 2.744V3.333c0-.46.373-.833.833-.833M5 15.833A.833.833 0 0 0 5 17.5h10a.833.833 0 0 0 0-1.667z"
  })));
};
export default SvgDownloadFlatTray;